import { usePatientDocuments } from '../model/usePatientDocuments'
import { PatientDocumentList } from './PatientDocumentList'

type PatientDocumentsProps = {
  patientId?: string
}

export function PatientDocuments({ patientId }: PatientDocumentsProps) {
  const {
    documents,
    totalCount,
    isDeleting,
    isFetching,
    page,
    pageSize,
    qrCode,
    onDelete,
    onSaveFileName,
    onSaveFileAnnotation,
    onUpload,
    onPageChange,
    onRefresh,
  } = usePatientDocuments(patientId)

  return (
    <PatientDocumentList
      documents={documents}
      totalCount={totalCount}
      isDeleting={isDeleting}
      isRefreshing={isFetching}
      onDelete={onDelete}
      onSaveFileName={onSaveFileName}
      onSaveFileAnnotation={onSaveFileAnnotation}
      onUpload={onUpload}
      onPageChange={onPageChange}
      onRefresh={onRefresh}
      page={page}
      qrCode={qrCode}
      pageSize={pageSize}
    />
  )
}
